export const UserRole = {
  HOST: 1,
  VENDOR: 2,
  VIEWER: 4,
} as const;
export type UserRole = (typeof UserRole)[keyof typeof UserRole];

export const AccountStatus = {
  ACTIVE: 'ACTIVE',
  SUSPENDED: 'SUSPENDED',
  BANNED: 'BANNED',
  DELETED: 'DELETED',
} as const;
export type AccountStatus = (typeof AccountStatus)[keyof typeof AccountStatus];

export const KycStatus = {
  PENDING: 'PENDING',
  SUBMITTED: 'SUBMITTED',
  VERIFIED: 'VERIFIED',
  REJECTED: 'REJECTED',
} as const;
export type KycStatus = (typeof KycStatus)[keyof typeof KycStatus];

/**
 * Enum for admin scope codes.
 */
export const AdminScopeCode = {
  TRUST: 'TRUST',
  FINANCIAL: 'FINANCIAL',
  LIVE_OPS: 'LIVE_OPS',
  AUDIT: 'AUDIT',
} as const;
export type AdminScopeCode = (typeof AdminScopeCode)[keyof typeof AdminScopeCode];

export const FeedbackCategory = {
  BUG: 'BUG',
  IDEA: 'IDEA',
  GENERAL: 'GENERAL',
} as const;
export type FeedbackCategory = (typeof FeedbackCategory)[keyof typeof FeedbackCategory];

export const NotificationCategory = {
  EVENT_REMINDERS: 'EVENT_REMINDERS',
  LIVE_ALERTS: 'LIVE_ALERTS',
  RECOMMENDATIONS: 'RECOMMENDATIONS',
  JOB_INVITATIONS: 'JOB_INVITATIONS',
  JOB_CONFIRMATIONS: 'JOB_CONFIRMATIONS',
  MESSAGES: 'MESSAGES',
  /** Vendor: payments, withdrawals, and earnings alerts. */
  PAYMENT_ALERTS: 'PAYMENT_ALERTS',
  TICKET_PURCHASES: 'TICKET_PURCHASES',
  CREW_UPDATES: 'CREW_UPDATES',
} as const;
export type NotificationCategory = (typeof NotificationCategory)[keyof typeof NotificationCategory];

export const VendorVerificationStatus = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  SUBMITTED: 'SUBMITTED',
  SUSPENDED: 'SUSPENDED',
} as const;
export type VendorVerificationStatus =
  (typeof VendorVerificationStatus)[keyof typeof VendorVerificationStatus];

export const VendorExperienceLevel = {
  BEGINNER: 'BEGINNER',
  INTERMEDIATE: 'INTERMEDIATE',
  EXPERT: 'EXPERT',
} as const;
export type VendorExperienceLevel =
  (typeof VendorExperienceLevel)[keyof typeof VendorExperienceLevel];

export const VendorTeamSize = {
  SOLO: 'SOLO',
  SMALL: 'SMALL',
  MEDIUM: 'MEDIUM',
  LARGE: 'LARGE',
} as const;
export type VendorTeamSize = (typeof VendorTeamSize)[keyof typeof VendorTeamSize];
